import cn from "classnames";

// Mui
import { TextField, Theme, CircularProgress } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

// Components
import CustomIcon from "components/CustomIcon";

// Others
import icons from "enums/icons";

type SearchInputVisualVariant = "default" | "hub" | "sidebarHub";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        inputSearch: {
            width: "65%",
            "& input": {
                fontSize: 24,
                textAlign: "left",
                paddingLeft: theme.spacing(1.5),
                letterSpacing: "normal",
                color: theme.palette.primary.main,
            },
            "& > div": {
                height: 66,
                boxShadow: "5px 5px 15px 5px #DEDEDE",
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3),
            },
            "& svg": {
                color: theme.palette.neutrals.dark,
            },
        },
        inputSearchFilled: {
            "& input": {
                letterSpacing: "2.67px",
                fontWeight: "normal",
                color: "#434566",
            },
        },
        searchProgressIcon: {
            width: "24px !important",
            height: "24px !important",
        },
        hubSelect: {
            width: "100%",
            marginBottom: theme.spacing(2),
            "& input": {
                fontSize: 14,
                textAlign: "left",
                paddingLeft: theme.spacing(1.5),
                letterSpacing: "normal",
                color: theme.palette.primary.main,
            },
            "& > div": {
                height: 44,
                boxShadow: "none",
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3),
            },
        },
        sidebarHubSelect: {
            "& input": {
                paddingLeft: theme.spacing(1),
            },
            "& > div": {
                height: 36,
                paddingLeft: theme.spacing(1),
            },
        },
    })
);

const SearchInput = ({
    placeholder,
    value,
    onChange,
    visualVariant = "default",
    showHint = false,
    loading,
}: {
    placeholder: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    visualVariant?: SearchInputVisualVariant;
    showHint?: boolean;
    loading?: boolean;
}): JSX.Element => {
    const classes = useStyles();
    const isCompactVariant = visualVariant === "hub" || visualVariant === "sidebarHub";

    return (
        <TextField
            autoComplete="off"
            placeholder={placeholder}
            autoFocus={isCompactVariant ? true : false}
            onChange={onChange}
            value={value}
            className={cn(classes.inputSearch, {
                [classes.inputSearchFilled]: value,
                [classes.hubSelect]: isCompactVariant,
                [classes.sidebarHubSelect]: visualVariant === "sidebarHub",
            })}
            InputProps={{
                startAdornment: (
                    <CustomIcon icon={icons.searchInverted} sx={isCompactVariant ? { fontSize: 20 } : {}} />
                ),
                endAdornment: loading ? <CircularProgress className={classes.searchProgressIcon} /> : <></>,
            }}
        />
    );
};

export default SearchInput;
